import Lottie from "lottie-react";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Loading from "../../../assets/images/gif/sdap-loading.json";
import { ROUTES } from "../../../configs/routes";
import { useAuthProvider } from "../../../hooks/useAuthProvider";
import {
  DISABLED_FEATURES,
  useFeatureToggle,
} from "../../../utils/feature-toggle/useFeatureToggle";
import { deepLinkService } from "../../../deeplink/DeepLinkService";
import "./DigitalLegacyAuth.scss";

export const DigitalLegacyAuth: React.FC = () => {
  const history = useHistory();
  const { login } = useAuthProvider();
  const { isDisabled } = useFeatureToggle();

  useEffect(() => {
    // NOTE:
    // Remove this condition once digital legacy has been released.
    // Remove `DIGITAL_LEGACY` from `DISABLED_FEATURES` enum as well.
    if (isDisabled(DISABLED_FEATURES.DIGITAL_LEGACY)) {
      history.replace(ROUTES.ERROR_404);
      return;
    }

    const deepLink = deepLinkService.get();
    const redirectURL = deepLink?.authRedirect ?? ROUTES.MYDATA;
    login("DL", { redirectURL, isDigitalLegacy: true });
  }, []);

  return (
    <Lottie
      className="dl-route__loading"
      animationData={Loading}
      loop={true}
      style={{ width: 60, height: 60 }}
    />
  );
};

export default DigitalLegacyAuth;
